import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Spinner, PageHeader } from "@/components/common";
import { api, errMsg } from "@/lib/api";

export default function SellerSettings() {
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/seller/profile").then((r) => setF({ store_name: r.data.store_name, bio: r.data.bio || "", country: r.data.country || "", phone: r.data.phone || "" })); }, []);
  if (!f) return <Spinner />;
  const save = async (e) => {
    e.preventDefault();
    try { await api.put("/seller/profile", f); toast.success("Store profile saved"); } catch (err) { toast.error(errMsg(err)); }
  };
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div className="max-w-2xl">
      <PageHeader eyebrow="Profile & settings" title="Store settings" />
      <form onSubmit={save} className="card-surface space-y-4 p-6">
        <div className="space-y-2"><Label>Store name (shown on your templates)</Label><Input data-testid="settings-store-name-input" value={f.store_name} onChange={set("store_name")} required minLength={2} /></div>
        <div className="space-y-2"><Label>Bio</Label><Textarea data-testid="settings-bio-input" value={f.bio} onChange={set("bio")} /></div>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-2"><Label>Country</Label><Input data-testid="settings-country-input" value={f.country} onChange={set("country")} /></div>
          <div className="space-y-2"><Label>Phone</Label><Input data-testid="settings-phone-input" value={f.phone} onChange={set("phone")} /></div>
        </div>
        <Button type="submit" data-testid="settings-save-btn">Save</Button>
      </form>
    </div>
  );
}
